import Validate from 'libs/validate';

import { NEW_VALUE_PREFIX } from './FormDestinationEmail.constants';

export function destinationEmailToOption(destinationEmail) {
  const { id, destinationEmail: email, location } = destinationEmail;

  return { id, title: email, key: email, value: email, location };
}
export function createEmailOptions(destinationEmails, locationId) {
  return destinationEmails
    .filter(({ location }) => location === (locationId || null))
    .map(destinationEmailToOption);
}

export function isValidEmail(email) {
  return Validate.validate('email', email);
}

export function isAnOption(email, options) {
  return options.some(({ title }) => title === email);
}

export function newValueToOption(value) {
  const title = `${NEW_VALUE_PREFIX} ${value}`;

  return { title, key: title, value: title };
}

export function optionToEmail(option) {
  const { title } = option;
  return title.replace(new RegExp(`^${NEW_VALUE_PREFIX} `), '');
}
